(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["email-capture-button-script"] && !Shopify.designMode) return;
  try {
    class EmailCaptureButton extends HTMLElement {
  static autoOpenTriggered = false;

  constructor() {
    super();
    this.controller = new AbortController();
    this.autoOpenTimeoutId = null;
  }

  async connectedCallback() {
    if (this.controller.signal.aborted) {
      this.controller = new AbortController();
    }

    const opensEmailCaptureModal = this.dataset.opensEmailCaptureModal === 'true';
    const $btn = this.querySelector('button.js-email-capture-btn, button[data-waitlist-modal-id]');
    if (!$btn || $btn.disabled) {
      return;
    }

    if (opensEmailCaptureModal) {
      const modalId = this.dataset.waitlistModalId;

      if (modalId) {
        const modal = document.getElementById(modalId);
        if (modal && modal.parentElement !== document.body) {
          document.body.appendChild(modal);
        }

        const overlayId = modalId.replace('KlaviyoWaitlistModal-', 'KlaviyoWaitlistModalOverlay-');
        const overlay = document.getElementById(overlayId);
        if (overlay && overlay.parentElement !== document.body) {
          document.body.appendChild(overlay);
        }

        const { signal } = this.controller;
        await customElements.whenDefined('klaviyo-waitlist-modal');
        if (signal.aborted || !this.isConnected) return;
        this.maybeAutoOpenModal(modal);

        $btn.addEventListener('click', () => {
          this.cancelAutoOpen();

          EmailCaptureButton.autoOpenTriggered = true;
        }, {
          signal: this.controller.signal,
          once: true,
        });
      }
    }
  }

  cancelAutoOpen() {
    if (this.autoOpenTimeoutId) {
      clearTimeout(this.autoOpenTimeoutId);
      this.autoOpenTimeoutId = null;
    }
  }

  maybeAutoOpenModal(modal) {
    const shouldAutoOpen = this.dataset.autoOpen === 'true';
    if (!shouldAutoOpen || EmailCaptureButton.autoOpenTriggered) {
      return;
    }

    const delaySeconds = parseFloat(this.dataset.autoOpenDelay) || 0;

    const delayMs = Math.max(delaySeconds * 1000, 100);

    this.autoOpenTimeoutId = setTimeout(() => {
      if (EmailCaptureButton.autoOpenTriggered) {
        return;
      }

      if (modal && typeof modal.open === 'function') {
        EmailCaptureButton.autoOpenTriggered = true;
        this.querySelector('button.js-email-capture-btn, button[data-waitlist-modal-id]')?.click();
      }
    }, delayMs);
  }

  disconnectedCallback() {
    this.controller.abort();
    this.cancelAutoOpen();
  }
}

function init() {
  if (customElements.get('email-capture-button')) {
    return;
  }
  customElements.define('email-capture-button', EmailCaptureButton);
}

init();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gorgias-chat"] && !Shopify.designMode) return;
  try {
    /**
 * Custom element that manages Gorgias chat widget behavior.
 * Adds click-outside-to-close functionality to the Gorgias chat window.
 */
class GorgiasChatManager extends HTMLElement {
  constructor() {
    super();
    this.abortController = null;
  }

  connectedCallback() {
    // Abort controller for event listener cleanup
    this.abortController = new AbortController();

    // Wait for Gorgias widget to be ready (scripts initialize automatically)
    const waitForReady = () => {
      if (window.GorgiasChat) {
        this.setupClickHandlers();
      } else {
        window.addEventListener('gorgias-widget-loaded', () => this.setupClickHandlers(), {
          once: true,
          signal: this.abortController?.signal
        });
      }
    };

    waitForReady();
  }

  setupClickHandlers() {
    document.addEventListener('click', this.handleDocumentClick.bind(this), {
      signal: this.abortController?.signal
    });
  }

  disconnectedCallback() {
    this.abortController?.abort();
    this.abortController = null;
  }

  /**
   * Handles clicks on the document for both opening and closing chat.
   * - Opens chat when clicking elements with [data-gorgias-chat-open]
   * - Closes chat when clicking outside the chat container
   * 
   * @param {MouseEvent} event - The click event from document
   */
  handleDocumentClick(event) {
    // Check if clicking a trigger element to open chat
    const trigger = event.target.closest('[data-gorgias-chat-open]');
    if (trigger) {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        window.GorgiasChat.open();
      }
      return;
    }

    // Close chat when clicking outside
    const container = document.querySelector('#gorgias-chat-container');
    if (!container) return;

    if (!container.contains(event.target)) {
      if (window.GorgiasChat && typeof window.GorgiasChat.close === 'function') {
        window.GorgiasChat.close();
      }
    }
  }
}

function initGorgiasChatManager() {
  if (customElements.get('gorgias-chat-manager')) {
    return;
  }
  customElements.define('gorgias-chat-manager', GorgiasChatManager);
}

initGorgiasChatManager();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-guide"] && !Shopify.designMode) return;
  try {
    function isHorizontallyOutOfView(element, container) {
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    return elementRect.left < containerRect.left || elementRect.right > containerRect.right;
  }

  function scrollSelectedAttributeIconographyIntoView(drawer) {
    if (!drawer) return;

    const selectedItems = drawer.querySelectorAll('.size-guide__attribute-iconography-item.is-selected');
    if (!selectedItems.length) return;

    selectedItems.forEach((selectedItem) => {
      const scrollContainer = selectedItem.closest('.size-guide__attribute-iconography-items');
      if (!scrollContainer) return;

      // Avoid forcing a right-scrolled initial state; only adjust when item is clipped.
      if (!isHorizontallyOutOfView(selectedItem, scrollContainer)) return;

      selectedItem.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    });
  }

  function initAttributeIconographyArrows(drawer) {
    if (!drawer) return;

    const groups = drawer.querySelectorAll('.size-guide__attribute-iconography-group');
    if (!groups.length) return;

    groups.forEach((group) => {
      const arrows = group.querySelector('.js-attribute-iconography-arrows');
      const overflowContainer = group.querySelector('.js-attribute-iconography-overflow-container');
      const scrollLeftArrow = group.querySelector('.js-attribute-iconography-scroll-left');
      const scrollRightArrow = group.querySelector('.js-attribute-iconography-scroll-right');

      if (!arrows || !overflowContainer || !scrollLeftArrow || !scrollRightArrow) {
        return;
      }

      const checkOverflow = () => {
        if (overflowContainer.scrollWidth > overflowContainer.clientWidth + 1) {
          arrows.classList.remove('hide');
        } else {
          arrows.classList.add('hide');
        }
      };

      const updateArrowStates = () => {
        const { scrollLeft, scrollWidth, clientWidth } = overflowContainer;
        scrollLeftArrow.disabled = scrollLeft <= 1;
        scrollRightArrow.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      };

      checkOverflow();
      updateArrowStates();

      if (group.dataset.arrowsInitialized === 'true') {
        return;
      }

      scrollLeftArrow.addEventListener('click', () => {
        overflowContainer.scrollBy({
          left: -200,
          behavior: 'smooth',
        });
      });

      scrollRightArrow.addEventListener('click', () => {
        overflowContainer.scrollBy({
          left: 200,
          behavior: 'smooth',
        });
      });

      overflowContainer.addEventListener('scroll', updateArrowStates);

      window.addEventListener('resize', () => {
        checkOverflow();
        updateArrowStates();
      });

      group.dataset.arrowsInitialized = 'true';
    });
  }

  function initSizeGuideDrawer(drawer) {
    if (!drawer) return;

    scrollSelectedAttributeIconographyIntoView(drawer);
    initAttributeIconographyArrows(drawer);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (drawer.hasAttribute('open')) {
            requestAnimationFrame(() => {
              scrollSelectedAttributeIconographyIntoView(drawer);
              initAttributeIconographyArrows(drawer);
            });
          }
        }
      }
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  function initSizeGuideSelectedItemScroll() {
    // Initialize every size guide drawer on the page. The set PDP renders one
    // per component product (`productSizeGuide-slot-N`); the standard PDP has one.
    const drawers = document.querySelectorAll('.size-guide__drawer');
    drawers.forEach((drawer) => initSizeGuideDrawer(drawer));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSizeGuideSelectedItemScroll, { once: true });
  } else {
    initSizeGuideSelectedItemScroll();
  }
  } catch(e) { console.error(e); }
})();

})();
